export default [
    {
        title: 'menu.perfs.partants',
        icon: ['fal', 'binoculars'],
        accessRights: 'CAPR',
		to: { name: 'partants' },
        mobile: true,
        desktop: true,
        home: true
    },
    {
        title: 'menu.perfs.resultats',
        icon: ['fal', 'flag-checkered'],
        accessRights: 'CAPR',
		to: { name: 'resultats' },
        mobile: true,
        desktop: true,
        home: true
    }
]
